import React, { useEffect, useState } from 'react';
import Icon from '@common/assets';
import { JDModalType } from '@components/position/jd/apply/modals';
import { useUserInfo } from '@repository/auth/useUserInfo';
import { useAddBookmark, useDeleteBookmark } from '@repository/position/usePosition';
import { PositionDetailVO } from '@domain/vo/position/jd/PositionDetailVO';
import Colors from '@domain/constant/colors';

import classnames from 'classnames/bind';
import styles from './bookmarkButton.module.scss';
const cx = classnames.bind(styles);

interface BookmarkButtonProps {
  positionSn?: number;
  positionDetail: PositionDetailVO;
  setModalState: (modalState: JDModalType) => void;
}

const BookmarkButton = ({ positionSn, positionDetail, setModalState }: BookmarkButtonProps) => {
  const [bookmarkYn, setBookmarkYn] = useState(false);
  const { data: userInfo, isLoading: isLoadingUserInfo } = useUserInfo();
  const isLogin = !!userInfo?.id;

  useEffect(() => {
    setBookmarkYn(positionDetail?.stateInfo?.bookmarkYn ?? false);
  }, [positionDetail]);

  const { mutate: deleteBookmark } = useDeleteBookmark(() => setBookmarkYn(false));

  const { mutate: addBookmark } = useAddBookmark(({ data }) => {
    if (data.firstBookmarkYn) setModalState('BOOKMARK_FIRST');
    else setModalState('BOOKMARK');
    setBookmarkYn(true);
  });

  const handleBookMark = async () => {
    if (!positionSn || isLoadingUserInfo) return;

    if (!isLogin) {
      setModalState('LOGIN');
      return;
    }

    if (bookmarkYn) deleteBookmark(positionSn);
    else addBookmark(positionSn);
  };

  return (
    <a className={cx('bookmarkBtn')} role="button" onClick={handleBookMark}>
      {bookmarkYn ? (
        <>
          <Icon name="bookmarkLightFilled" width={24} height={24} fill={Colors.C_GREEN_150} />
          북마크 완료
        </>
      ) : (
        <>
          <Icon name="bookmarkLight" width={24} height={24} />
          북마크 하기
        </>
      )}
    </a>
  );
};

export default BookmarkButton;
